import { CloseButton } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/solid';
import { Button } from '@heroui/react';
import _ from 'lodash';
import type { FC } from 'react';
import {
  DescriptionDetails,
  DescriptionList,
  DescriptionTerm,
} from '@/primitives/description-list.tsx';
import { Dialog, DialogBody, DialogTitle } from '@/primitives/dialog.tsx';

export interface OnboardJsonLineItemDialogProps {
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
  jsonLineItem: any;
  title: string;
}

const DescriptionLine = ({ propName, value }) => (
  <>
    <DescriptionTerm>
      {_(propName)
        .upperFirst()
        .replace(/([A-Z])/g, ' $1')}
    </DescriptionTerm>
    <DescriptionDetails>{value}</DescriptionDetails>
  </>
);

const OnboardJsonLineItemDialog: FC<OnboardJsonLineItemDialogProps> = ({
  isOpen,
  setOpen,
  jsonLineItem,
  title,
}) => {
  const keys = jsonLineItem ? Object.keys(jsonLineItem) : [];
  return (
    <Dialog onClose={setOpen} open={isOpen} size='5xl'>
      <div className='flex flex-row justify-between'>
        <DialogTitle>{title}</DialogTitle>
        <CloseButton as={Button} variant='light'>
          <XMarkIcon />
        </CloseButton>
      </div>
      <DialogBody>
        <DescriptionList>
          {!!keys.length &&
            keys.map(key => <DescriptionLine key={key} propName={key} value={jsonLineItem[key]} />)}
        </DescriptionList>
      </DialogBody>
    </Dialog>
  );
};

export default OnboardJsonLineItemDialog;
